import { Component, Input, OnInit } from '@angular/core';
import { Banner, ContentStoreService } from '@motivforce/mx-library-angular';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'app-default-main-layout',
  templateUrl: './default-main-layout.component.html',
  styleUrls: ['./default-main-layout.component.scss'],
})
export class DefaultMainLayoutComponent implements OnInit {
  @Input() banner: Banner | null;
  @Input() showSideWidgets = false;
  @Input() showLogo = false;

  constructor(private contentStore: ContentStoreService) {}

  ngOnInit(): void {
    this.contentStore.banner$.pipe(untilDestroyed(this), filter(Boolean)).subscribe((banner) => {
      if (!this.banner && banner && banner.imageUrl) {
        this.banner = banner;
      }
    });
  }
}
